export default "__VITE_ASSET__4a8641e6__"